var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6562 1.90625H3.34375C2.05141 1.90625 1 2.95766 1 4.25V11.75C1 13.0423 2.05141 14.0938 3.34375 14.0938H14.6562C15.9486 14.0938 17 13.0423 17 11.75V4.25C17 2.95766 15.9486 1.90625 14.6562 1.90625ZM16.0625 11.75C16.0625 12.5254 15.4317 13.1562 14.6562 13.1562H3.34375C2.56834 13.1562 1.9375 12.5254 1.9375 11.75V4.25C1.9375 3.47459 2.56834 2.84375 3.34375 2.84375H14.6562C15.4317 2.84375 16.0625 3.47459 16.0625 4.25V11.75Z",
    fill: "#73777C",
    stroke: "#73777C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84219 5.25875L11.5922 7.6025C11.7293 7.68816 11.8125 7.83838 11.8125 8C11.8125 8.16163 11.7292 8.31185 11.5922 8.3975L7.84216 10.7413C7.76628 10.7887 7.68006 10.8125 7.59372 10.8125C7.51556 10.8125 7.43731 10.793 7.3665 10.7538C7.21744 10.6711 7.12497 10.5142 7.12497 10.3438V5.65625C7.12497 5.48585 7.21744 5.32885 7.3665 5.24625C7.51553 5.16366 7.69766 5.16844 7.84219 5.25875Z",
    fill: "#73777C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.106f5ac6a47f35034ee322c0bf0d2d04.svg";
export { ForwardRef as ReactComponent };